<template>
    <div class="container">
        <el-page-header @back="$router.back()" :content="['创建培训报名','编辑培训报名信息'][type]"></el-page-header>
        <div class="content">
            <el-form :model="form" ref="form" :rules="rules" size="mini" class="form" label-width="130px">
                <el-form-item label="培训：" prop="trainId">
                    <template v-if="type == 0">
                        <el-select v-model="form.trainId" @change="trainIdChange">
                            <el-option v-for="(item,index) in trainList" :key="index" :value="item.TrainId" :label="item.TrainDescription.TrainFullName"></el-option>
                        </el-select>
                    </template>
                    <template v-else>
                        <span>{{form.trainName}}</span>
                    </template>
                </el-form-item>
                <template v-if="form.trainId">
                    <el-form-item label="培训时间：" prop="trainTime" required>
                        <span>{{trainTime}}</span>
                    </el-form-item>
                    <el-form-item label="报名时间：" prop="enrollTime">
                        <el-date-picker
                            v-model="form.enrollTime"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-ddTHH:mm:ss"
                            :picker-options="enrollTimeOptions">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="报名须知：" prop="enrollNotice">
                        <Editor v-model="form.enrollNotice" :oss-options="UploaderOptions"></Editor>
                    </el-form-item>
                    <el-form-item label="上传图片附件:">
                        <Images 
                            v-model="enrollAttachmentImages"
                            :fileMax="10"
                            :fileSize="10 * 1024 * 1024" 
                            :uploaderOptions="UploaderOptions"
                        ></Images>
                    </el-form-item>
                    <el-form-item label="上传文档附件:">
                        <Files 
                            label="文档附件"
                            v-model="enrollAttachmentFiles"
                            :fileMax="10"
                            :fileSize="10 * 1024 * 1024" 
                            :uploaderOptions="UploaderOptions"
                        ></Files>
                    </el-form-item>
                    <el-form-item label="参训须知：" prop="reportNotice">
                        <Editor v-model="form.reportNotice" :oss-options="UploaderOptions"></Editor>
                    </el-form-item>
                    <el-form-item label="上传图片附件:">
                        <Images 
                            v-model="reportAttachmentImages"
                            :fileMax="10"
                            :fileSize="10 * 1024 * 1024" 
                            :uploaderOptions="UploaderOptions"
                        ></Images>
                    </el-form-item>
                    <el-form-item label="上传文档附件:">
                        <Files 
                            label="文档附件"
                            v-model="reportAttachmentFiles"
                            :fileMax="10"
                            :fileSize="10 * 1024 * 1024" 
                            :uploaderOptions="UploaderOptions"
                        ></Files>
                    </el-form-item>
                    <el-divider></el-divider>
                    <el-descriptions title="学员信息设置"></el-descriptions>
                    <template>
                        <el-form-item label="肖像照片：" prop="fieldsOptions.portraitPhoto" required>
                            <el-radio-group v-model="form.fieldsOptions.portraitPhoto">
                                <el-radio :label="1">必须上传</el-radio>
                                <el-radio :label="0">无需上传</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="服装尺码：" prop="fieldsOptions.clothingSizes" required>
                            <el-radio-group v-model="form.fieldsOptions.clothingSizes">
                                <el-radio :label="1">必须填写</el-radio>
                                <el-radio :label="0">无需填写</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="通讯地址：" prop="fieldsOptions.address" required>
                            <el-radio-group v-model="form.fieldsOptions.address">
                                <el-radio :label="0">必须填写所在区域和详细地址</el-radio>
                                <el-radio :label="1">必须填写所在区域，无需填写详细地址</el-radio>
                                <el-radio :label="2">无需填写</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="工作单位：" prop="fieldsOptions.companyName" required>
                            <el-radio-group v-model="form.fieldsOptions.companyName">
                                <el-radio :label="1">必须填写</el-radio>
                                <el-radio :label="0">无需填写</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </template>
                    <template v-for="(item,index) in classList">
                        <div :key="index">
                            <el-divider></el-divider>
                            <el-descriptions>
                                <template slot="title">报名资格设置：<span style="font-size: 0.8em;color: #444444">{{item.ClassName}}</span></template>
                            </el-descriptions>
                            <el-form-item label="说明文本：" :prop="`classLimit.${index}.desc`" :rules="classRules.desc">
                                <el-input type="textarea" :rows="5" v-model="form.classLimit[index].desc" style="max-width: 700px" ></el-input>
                            </el-form-item>
                            <el-row type="flex">
                                <el-col :span="4">
                                    <el-form-item :label="item.ClassType == 1 ? '裁判员证书：' : '教练员证书：'" :prop="`classLimit.${index}.levelLimit`" :rules="classRules.levelLimit">
                                        <el-select v-model="form.classLimit[index].levelLimit">
                                            <el-option label="不需要" :value="0"></el-option>
                                            <el-option v-for="(levelItem,levelIndex) in getFilterLeves(levelObj[item.EventsId + '-' + item.ClassType], item.ClassLevel)" :key="levelIndex" :value="levelItem.LevelNo" :label="levelItem.LevelName + '证书'"></el-option>
                                            <el-option label="其他" :value="-1"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="4" v-if="form.classLimit[index].levelLimit == -1">
                                    <el-form-item label="名称：" :prop="'otherCertsName'+index" :rules="classRules.otherCertsName">
                                        <el-input v-model="form.classLimit[index].otherCertsName" maxlength="10"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6" v-if="form.classLimit[index].levelLimit != 0">
                                    <el-form-item  label="是否必填：" :prop="`classLimit.${index}.certsRequried`" :rules="classRules.certsRequried">
                                        <el-radio-group v-model="form.classLimit[index].certsRequried">
                                            <el-radio :label="1">必须选择或上传</el-radio>
                                            <el-radio :label="0">可选</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item :label="item.ClassType == 1 ? '执裁经历：' : '执教经历：'" :prop="`classLimit.${index}.workLimit`" :rules="classRules.workLimit">
                                <el-radio-group v-model="form.classLimit[index].workLimit">
                                    <template v-if="form.classLimit[index].levelLimit == 0">
                                        <el-radio :label="1">必须填写</el-radio>
                                        <el-radio :label="0">不填写（不显示）</el-radio>
                                        <el-radio :label="3">可选</el-radio>
                                    </template>
                                    <template v-else>
                                        <el-radio :label="1">必须填写</el-radio>
                                        <el-radio :label="0">不填写（不显示）</el-radio>
                                        <el-radio :label="3">可选</el-radio>
                                        <el-radio :label="2">没有证书时必须填写，否则可选</el-radio>
                                    </template>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="学员性别限制:" required style="margin-bottom:20px">
                                <el-radio-group v-model="form.classLimit[index].GenderLimit" border>
                                    <el-radio :label="1">男</el-radio>
                                    <el-radio :label="2">女</el-radio>
                                    <el-radio :label="3">男女不限</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <template v-if="[1,3,4].includes(form.classLimit[index].GenderLimit)">
                                <el-form-item :label="`${[3,4].includes(form.classLimit[index].GenderLimit)?'男':''}学员年龄限制:`"
                                    :prop="'maleBirthday'+index" 
                                    :rules="classRules.birthday"  
                                    style="margin-bottom:20px">
                                    <div class="more">
                                        <div>
                                            <span class="label">最早出生：</span>
                                            <el-input v-model.number="form.classLimit[index].MaleBirthdayMin[0]"></el-input>年
                                            <el-input v-model.number="form.classLimit[index].MaleBirthdayMin[1]"></el-input>月
                                            <el-input v-model.number="form.classLimit[index].MaleBirthdayMin[2]"></el-input>日
                                        </div>
                                        <div>
                                            <span class="label">最晚出生：</span>
                                            <el-input v-model.number="form.classLimit[index].MaleBirthdayMax[0]"></el-input>年
                                            <el-input v-model.number="form.classLimit[index].MaleBirthdayMax[1]"></el-input>月
                                            <el-input v-model.number="form.classLimit[index].MaleBirthdayMax[2]"></el-input>日
                                        </div>
                                    </div>
                                </el-form-item>
                            </template>
                            <template v-if="[2,3,4].includes(form.classLimit[index].GenderLimit)">
                                <el-form-item :label="`${[3,4].includes(form.classLimit[index].GenderLimit)?'女':''}学员年龄限制:`" 
                                    :prop="'femaleBirthday'+index" 
                                    :rules="classRules.birthday" 
                                    style="margin-bottom:20px">
                                    <div class="more">
                                        <div>
                                            <span class="label">最早出生：</span>
                                            <el-input v-model.number="form.classLimit[index].FemaleBirthdayMin[0]"></el-input>年
                                            <el-input v-model.number="form.classLimit[index].FemaleBirthdayMin[1]"></el-input>月
                                            <el-input v-model.number="form.classLimit[index].FemaleBirthdayMin[2]"></el-input>日
                                        </div>
                                        <div>
                                            <span class="label">最晚出生：</span>
                                            <el-input v-model.number="form.classLimit[index].FemaleBirthdayMax[0]"></el-input>年
                                            <el-input v-model.number="form.classLimit[index].FemaleBirthdayMax[1]"></el-input>月
                                            <el-input v-model.number="form.classLimit[index].FemaleBirthdayMax[2]"></el-input>日
                                        </div>
                                    </div>
                                </el-form-item>
                            </template>
                        </div>
                    </template>

                    <el-divider></el-divider>
                    <el-descriptions title="法律文件设置"></el-descriptions>
                    <el-form-item>
                        <Files 
                            label="法律文件"
                            v-model="legalFiles"
                            :fileType="['pdf']"
                            :fileMax="99"
                            :fileSize="100 * 1024 * 1024" 
                            :inputMaxlength="20"
                            :uploaderOptions="UploaderOptions"
                        ></Files>
                    </el-form-item>
                    <el-divider></el-divider>
                    <el-descriptions title="培训服务费收款设置"></el-descriptions>
                    <el-row>
                        <el-form-item label="在线支付：" prop="onlinePaymentDisabled" required>
                            <el-radio-group v-model="form.onlinePaymentDisabled">
                                <el-radio :label="0">可用在线支付和转账</el-radio>
                                <el-radio :label="1">禁用在线支付（可用转账）</el-radio>
                                <el-radio :label="2">跳过支付（由第三方收款）</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-row>
                    <el-row type="flex">
                        <el-col :span="10" class="classFee">
                            <div><span style="line-height: 40px;">培训服务费</span></div>
                            <template v-for="(item,index) in classList">
                                <el-form-item :label="item.ClassName + '：'" :key="index" :rules="classFeeRule" :prop="`classLimit.${index}.fee`">
                                    <el-input v-model="form.classLimit[index].fee" style="width: 100px" ></el-input> 元/学员
                                </el-form-item>
                            </template>
                        </el-col>
                        <el-col :span="1">
                            <el-divider direction="vertical" class="vertical"></el-divider>
                        </el-col>
                        <el-col :span="10">
                            <div><span style="line-height: 40px;">收款账户信息</span></div>
                            <el-form-item label="开户名称：" prop="feeTransferAccount.name">
                                <el-input v-model="form.feeTransferAccount.name"></el-input>
                            </el-form-item>
                            <el-form-item label="开户银行：" prop="feeTransferAccount.bank">
                                <el-input v-model="form.feeTransferAccount.bank"></el-input>
                            </el-form-item>
                            <el-form-item label="账号：" prop="feeTransferAccount.number">
                                <el-input v-model="form.feeTransferAccount.number"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-divider></el-divider>
                    <el-row>
                        <el-button type="primary" style="margin-left: 100px" @click="save"> 保存 </el-button>
                    </el-row>
                </template>
            </el-form>
        </div>
    </div>
</template>
<script>
import utils from '@/utils';
import Files from '@/components/common/Files';
import Images from '@/components/common/Images';
import Editor from '@/components/Editor';
export default {
    name: 'trainingEnrollDetail',
    components: {
        Files,
        Images,
        Editor
    },
    data() {
        let id = +this.$route.params.id;
        return {
            type: id == 0 ? 0 : 1,
            trainEnrollId: id,
            form: {
                trainId: null,
                trainName: "",
                trainTime: null,
                enrollTime: [],
                enrollNotice: "",
                reportNotice: "",
                fieldsOptions: {
                    portraitPhoto: 1,
                    clothingSizes: 1,
                    address: 0,
                    companyName: 0,
                },
                classLimit: [],
                feeTransferAccount: {
                    name: "",
                    bank: "",
                    number: ""
                },
                onlinePaymentDisabled: 0,
            },
            trainList: [],
            classList: [],
            levelObj: {},
            levelMap: new Map(),
            UploaderOptions: {},
            enrollAttachmentImages: [],
            enrollAttachmentFiles: [],
            reportAttachmentImages: [],
            reportAttachmentFiles: [],
            legalFiles: []
        };
    },

    created() {
        this.$api.GetTrainEnrollManageInit({
            "TrainEnrollId": this.trainEnrollId
        }).then(data=>{
            if(data.Code == 0){
                if(!this.type){
                    this.trainEnrollId = data.NextTrainEnrollId;
                }
                this.UploaderOptions = data.UploadOptions;
            }
        })
        if(this.type){
            this.getDetailData();
        }else{
            this.$api.GetTrainListWithoutCreateEnroll().then(data=>{
                if(data.Code == 0){
                    this.trainList = data.TrainList || [];
                }
            })
        }
    },
    computed:{
        enrollTimeOptions(){
            let [BeginTime] = this.form.trainTime;
            return {
                disabledDate(time){
                    if(BeginTime){
                        return time.getTime() > new Date(BeginTime).getTime();
                    }else{
                        return true;
                    }
                }
            }
        },
        rules(){
            return {
                trainId: [{required:true,message:"请选择培训"}],
                enrollTime: [
                    {required:true,validator:(rule, value, callback)=>{
                        if(!value || value.length == 0 || !value[0] || !value[1]){
                            callback(new Error('请选择报名时间'));
                        }else{
                            callback();
                        }
                    }}
                ],
                enrollNotice:[
                    {validator:(_, value, callback)=>{
                        if((this.enrollAttachmentImages.length > 0 || this.enrollAttachmentFiles.length > 0) && !value){
                            callback(new Error('上传附件，必须填写报名须知'));
                        }else{
                            callback();
                        }
                    }}
                ],
                reportNotice:[
                    {required:true, message: "请填写报道通知"}
                ],
                'feeTransferAccount.name': [{required:true,min: 5, max: 20, message:"限制5 ~ 20个字符"}],
                'feeTransferAccount.bank': [{required:true,min: 5, max: 20, message:"限制5 ~ 20个字符"}],
                'feeTransferAccount.number': [
                    {required:true,min: 5, max: 20, message:"限制10 ~ 20个字符"},
                    {validator:(rule, value, callback)=>{
                        let valueNum = Number(value);
                        if(isNaN(valueNum) || value.indexOf('.') > -1){
                            callback(new Error('格式不正确'));
                        }else{
                            callback();
                        }
                    }}
                ]
            }
        },
        classRules(){
            return {
                desc: [{required:true,message:"请填写培训要求说明"}],
                levelLimit: [{required:true,message:"请选择裁判员证书要求"}],
                otherCertsName:[
                    {validator:(rule, value, callback)=>{
                        var index = parseInt(rule.field.substr(-1));
                        var obj = this.form.classLimit[index];
                        var levelLimit = obj.levelLimit;
                        var name = obj.otherCertsName;
                        if (levelLimit == -1){
                            if (!name) {
                                callback(new Error("请输入其他材料名称"));
                            } else if (name.length < 2 || name.length > 10) {
                                callback(new Error("限制2 ~ 10个字符"));
                            } else {
                                callback();
                            }
                        } else {
                            callback();
                        }
                    }, trigger: 'blur'}
                ],
                certsRequried: [{required:true,message:"请选择证书是否必填"}],
                workLimit: [{required:true,message:"请选择执裁经历要求"}],
                birthday:[
                    {validator:(rule, value, callback)=>{
                        var index = parseInt(rule.field.substr(-1));
                        var obj = this.form.classLimit[index];
                        var y = new Date().getFullYear(),
                            min = [],
                            max = [],
                            error = null;
                        if(rule.field.indexOf('femaleBirthday') > -1){
                            min = obj.FemaleBirthdayMin,
                            max = obj.FemaleBirthdayMax;
                        }else{
                            min = obj.MaleBirthdayMin,
                            max = obj.MaleBirthdayMax;
                        }
                        let minY = min[0], minM = min[1], minD = min[2],
                            maxY = max[0], maxM = max[1], maxD = max[2];
                        if((minY && minY > y) || (maxY && maxY > y)){
                            error = '出生年份不能大于今年';
                        }else if((minY && minY < 1900) || (maxY && maxY < 1900)){
                            error = '出生年份不能小于1900年';
                        }else if(minY && maxY && minY > maxY){
                            error = '最早出生年份不能大于最晚出生年份';
                        }else if(minY && new Date(`${minY}-${minM}-${minD}`) == 'Invalid Date'){
                            error = '最早出生日期格式不正确';
                        }else if(maxY && new Date(`${maxY}-${maxM}-${maxD}`) == 'Invalid Date'){
                            error = '最晚出生日期格式不正确';
                        }
                        if(error){
                            callback(new Error(error));
                        }else{
                            callback();
                        }
                    }, trigger: 'blur'}
                ],
            }
        },
        classFeeRule(){
            return [
                {required:true,message:"请输入培训费"},
                {validator:(rule, value, callback)=>{
                    let valueNum = Number(value);
                    if(isNaN(valueNum)){
                        callback(new Error('请输入数字'));
                    }else if(valueNum < 0 || valueNum > 99999){
                        callback(new Error('限制0 ~ 99999元'));
                    }else if(value.toString().indexOf('.') > -1){
                        callback(new Error('只支持整数'));
                    }else{
                        callback();
                    }
                }},
            ]
        },
        trainTime(){
            if(this.form.trainTime){
                let [BeginTime, EndTime] = this.form.trainTime;
                return utils.dateFormat(BeginTime, 'yyyy-MM-dd HH:mm:ss') + '~' + utils.dateFormat(EndTime, 'yyyy-MM-dd HH:mm:ss');
            }
            return '';
        }
    },
    methods: {
        getDetailData(){
            var loading = this.$loading({
                text: '数据读取中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.8)'
            })
            this.$api.GetTrainEnrollSetting({
                "TrainEnrollId": this.trainEnrollId
            }).then(data=>{
                loading.close();
                if(data.Code == 0){
                    let detail = data.TrainEnrollSetting;
                    let form = this.form;

                    form.trainId = detail.Train.TrainId;
                    form.trainName = detail.Train.TrainDescription.TrainFullName;

                    let trainTime = detail.Train.TrainTime;
                    form.trainTime = [trainTime.BeginTime, trainTime.EndTime];

                    let trainEnroll = detail.TrainEnroll;
                    let {BeginTime, EndTime} = trainEnroll.EnrollTime;
                    form.enrollTime = [BeginTime, EndTime];
                    form.enrollNotice = trainEnroll.EnrollNotice;
                    form.reportNotice = trainEnroll.ReportNotice;

                    let {
                        portrait_photo,
                        clothing_sizes,
                        address,
                        company_name,
                    } = trainEnroll.FieldsOptions;
                    form.fieldsOptions = {
                        portraitPhoto: portrait_photo == 0 ? 0 : 1,
                        clothingSizes: clothing_sizes == 0 ? 0 : 1,
                        address: address == 0 ? 0 : (address == 1 ? 1 : 2),
                        companyName: company_name == 0 ? 0 : 1,
                    };
                    form.feeTransferAccount = trainEnroll.FeeTransferAccount;
                    form.onlinePaymentDisabled = trainEnroll.OnlinePaymentDisabled;
                    //报名附件
                    let enrollImages = detail.EnrollPictureFiles || [];
                    this.enrollAttachmentImages = enrollImages.map(item=>{
                        return {
                            url: item.FileUrl,
                            loading: false
                        }
                    })
                    let enrollFiles = detail.EnrollDocFiles || [];
                    this.enrollAttachmentFiles = enrollFiles.map(item=>{
                        let name = item.FileName,
                            url = item.FileUrl;
                        let type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
                        if(!type){
                            type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
                        }
                        return {
                            url,
                            name: name.substr(0, name.lastIndexOf('.')) || name,
                            size: item.FileSize,
                            loading: false,
                            type
                        }
                    })
                    //报到附件
                    let reportImages = detail.CheckinPictureFiles || [];
                    this.reportAttachmentImages = reportImages.map(item=>{
                        return {
                            url: item.FileUrl,
                            loading: false
                        }
                    })
                    let reportFiles = detail.CheckinDocFiles || [];
                    this.reportAttachmentFiles = reportFiles.map(item=>{
                        let name = item.FileName,
                            url = item.FileUrl;
                        let type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
                        if(!type){
                            type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
                        }
                        return {
                            url,
                            name: name.substr(0, name.lastIndexOf('.')) || name,
                            size: item.FileSize,
                            loading: false,
                            type
                        }
                    })
                    //法律文件
                    let legalFiles = detail.TrainEnrollFile || [];
                    this.legalFiles = legalFiles.map(item=>{
                        let name = item.InstrumentName,
                            url = item.InstrumentUrl;
                        let type = name.substr(name.lastIndexOf('.')).substr(1).toLowerCase();
                        if(!type){
                            type = url.substr(url.lastIndexOf('.')).substr(1).toLowerCase();
                        }
                        return {
                            url,
                            name: name.substr(0, name.lastIndexOf('.')) || name,
                            size: '',
                            loading: false,
                            type
                        }
                    });

                    let trainEnrollClass = detail.TrainEnrollClass || [];
                    let levelMap = this.levelMap;
                    let classLimit = [],
                        classList = [];
                    trainEnrollClass.forEach(item => {
                        let {
                            TrainClassId: ClassId,
                            TrainClassName: ClassName,
                            EventsId,
                            EventsName,
                            ClassType,
                            ClassLevel,
                            LevelName,
                            GenderLimit,
                            MaleBirthdayMin,
                            MaleBirthdayMax,
                            FemaleBirthdayMin,
                            FemaleBirthdayMax
                        } = item;
                        classList.push({
                            ClassId,
                            ClassName,
                            EventsId,
                            EventsName,
                            ClassType,
                            ClassLevel,
                            LevelName,
                        })
                        MaleBirthdayMin = MaleBirthdayMin ? this.setDate(MaleBirthdayMin) : [null, 1, 1];
                        MaleBirthdayMax = MaleBirthdayMax ? this.setDate(MaleBirthdayMax) : [null, 12, 31];
                        FemaleBirthdayMin = FemaleBirthdayMin ? this.setDate(FemaleBirthdayMin) : [null, 1, 1];
                        FemaleBirthdayMax = FemaleBirthdayMax ? this.setDate(FemaleBirthdayMax) : [null, 12, 31];
                        classLimit.push({
                            levelLimit: item.HadCertLevelLimit || 0,
                            workLimit: item.ExperienceInput || 0,
                            otherCertsName: item.HadOtherCertsName,
                            certsRequried: item.HadCertsRequired || 1,
                            desc: item.TrainClassDesc,
                            fee: item.Fee,
                            GenderLimit,
                            MaleBirthdayMin,
                            MaleBirthdayMax,
                            FemaleBirthdayMin,
                            FemaleBirthdayMax,
                        })
                        let key = item.EventsId + '-' + item.ClassType;
                        if(!levelMap.get(key)){
                            levelMap.set(key, true);
                            if(item.ClassType == 1){
                                this.getRefereeLevel(item.EventsId);
                            }else if(item.ClassType == 2){
                                this.getCoachLevel(item.EventsId);
                            }
                        }
                    })
                    this.classList = classList;
                    form.classLimit = classLimit;
                    this.getLevel();
                }
            }).catch(()=>{
                loading.close();
            })
        },
        getClassList(){
            this.$api.GetTrainClasses({
                TrainId: this.form.trainId
            }).then(data=>{
                if(data.Code == 0){
                    let classList = data.TrainClasses || [];
                    let classLimit = [];
                    let levelMap = this.levelMap;
                    classList.forEach(item => {
                        classLimit.push({
                            levelLimit: 0,
                            workLimit: 0,
                            otherCertsName: "",
                            certsRequried: 1,
                            desc: "",
                            fee: "",
                            GenderLimit: 3,
                            MaleBirthdayMin: [null, 1, 1],
                            MaleBirthdayMax: [null, 12, 31],
                            FemaleBirthdayMin: [null, 1, 1],
                            FemaleBirthdayMax: [null, 12, 31]
                        })
                        let key = item.EventsId + '-' + item.ClassType;
                        if(!levelMap.get(key)){
                            levelMap.set(key, true);
                            if(item.ClassType == 1){
                                this.getRefereeLevel(item.EventsId);
                            }else if(item.ClassType == 2){
                                this.getCoachLevel(item.EventsId);
                            }
                        }
                    });
                    this.classList = classList;
                    this.form.classLimit = classLimit;
                }
            })
        },
        getRefereeLevel(eventsId){
            this.$api.GetRefereeLevelDictionary({
                "EventsId": eventsId
            }).then(data=>{
                if(data.Code == 0){
                    let key = eventsId + '-1',
                        levels = data.Levels || [];
                    this.$set(this.levelObj, key, levels)
                }
            });
        },
        getCoachLevel(eventsId){
            this.$api.GetCoachLevelDictionary({
                "EventsId": eventsId
            }).then(data=>{
                if(data.Code == 0){
                    let key = eventsId + '-2',
                        levels = data.Levels || [];
                    this.$set(this.levelObj, key, levels)
                }
            });
        },
        getFilterLeves(levels = [], level){
            let filters = levels.filter(item=>item.LevelNo > level);
            return filters;
        },
        setDate(date){
            date = new Date(date);
            return [date.getFullYear(), date.getMonth()+1, date.getDate()];
        },
        trainIdChange(){
            let trainId = this.form.trainId;
            let trainObj = this.trainList.filter(item=> item.TrainId == trainId)[0];
            this.$refs.form.resetFields();
            this.$nextTick(function(){
                this.form.trainId = trainId;
                this.form.trainTime = [trainObj.TrainTime.BeginTime, trainObj.TrainTime.EndTime];
                this.files = [];
                this.getClassList();
            });
        },
        save(){
            this.$refs['form'].validate((valid)=>{
                if(valid){
                    let trainEnrollId = this.trainEnrollId;
                    let form = this.form;
                    let enrollImages = this.enrollAttachmentImages.filter(item=>!item.loading).map(item=>({
                        "FileName": item.name,
                        "FileUrl": item.url,
                        "FileType": 1,
                        "FileSize": item.size
                    }))
                    let enrollFiles = this.enrollAttachmentFiles.filter(item=>!item.loading && item.name).map(item=>({
                        "FileName": item.name + '.' + item.type,
                        "FileUrl": item.url,
                        "FileType": 0,
                        "FileSize": item.size
                    }))
                    let reportImages = this.reportAttachmentImages.filter(item=>!item.loading).map(item=>({
                        "FileName": item.name,
                        "FileUrl": item.url,
                        "FileType": 1,
                        "FileSize": item.size
                    }))
                    let reportFiles = this.reportAttachmentFiles.filter(item=>!item.loading && item.name).map(item=>({
                        "FileName": item.name + '.' + item.type,
                        "FileUrl": item.url,
                        "FileType": 0,
                        "FileSize": item.size
                    }))
                    let trainEnrollFile = this.legalFiles.filter(item=>!item.loading && item.name).map(item=>({
                        "TrainInstrumentId": 0,
                        "TrainEnrollId": trainEnrollId,
                        "InstrumentName": item.name + '.' + item.type,
                        "InstrumentUrl": item.url
                    }));
                    let classList = this.classList,
                        classLimit = form.classLimit;
                    let trainEnrollClass = [];
                    for(let i=0;i<classList.length;i++){
                        let obj = classList[i],
                            value = classLimit[i];
                        let MaleBirthdayMin,
                            MaleBirthdayMax,
                            FemaleBirthdayMin,
                            FemaleBirthdayMax;
                        if([1,3,4].includes(value.GenderLimit)){
                            let BMin = value.MaleBirthdayMin,
                                BMax = value.MaleBirthdayMax;
                            MaleBirthdayMin = BMin[0] ? utils.dateFormat(BMin.join("-"),'yyyy-MM-dd') : null;
                            MaleBirthdayMax = BMax[0] ? utils.dateFormat(BMax.join("-"),'yyyy-MM-dd') : null;
                        }
                        if([2,3,4].includes(value.GenderLimit)){
                            let BMin = value.FemaleBirthdayMin,
                                BMax = value.FemaleBirthdayMax;
                            FemaleBirthdayMin = BMin[0] ? utils.dateFormat(BMin.join("-"),'yyyy-MM-dd') : null;
                            FemaleBirthdayMax = BMax[0] ? utils.dateFormat(BMax.join("-"),'yyyy-MM-dd') : null;
                        }
                        trainEnrollClass.push({
                            "Id": 0,
                            "TrainEnrollId": trainEnrollId,
                            "TrainClassId": obj.ClassId,
                            "EventsId": obj.EventsId,
                            "TrainClassName": obj.ClassName,
                            "TrainClassDesc": value.desc,
                            "HadCertLevelLimit": value.levelLimit,
                            "HadOtherCertsName": value.levelLimit != -1 ? null : value.otherCertsName,
                            "HadCertsRequired": value.levelLimit == 0 ? 0 : value.certsRequried,
                            "ExperienceInput": value.workLimit,
                            "Fee": value.fee,
                            "GenderLimit": value.GenderLimit,
                            MaleBirthdayMin,
                            MaleBirthdayMax,
                            FemaleBirthdayMin,
                            FemaleBirthdayMax,
                        })
                    }
                    let sendData = {
                        "Setting": {
                            "TrainEnroll": {
                                "TrainId": form.trainId,
                                "TrainEnrollId": trainEnrollId,
                                "EnrollTime": {
                                    "BeginTime": form.enrollTime[0],
                                    "EndTime": form.enrollTime[1]
                                },
                                "EnrollNotice": form.enrollNotice,
                                "ReportNotice": form.reportNotice,
                                "FieldsOptions": {
                                    "portrait_photo": form.fieldsOptions.portraitPhoto,
                                    "clothing_sizes": form.fieldsOptions.clothingSizes,
                                    "address": form.fieldsOptions.address,
                                    "company_name": form.fieldsOptions.companyName,
                                },
                                "FeeTransferAccount": {
                                    "name": form.feeTransferAccount.name,
                                    "bank": form.feeTransferAccount.bank,
                                    "number": form.feeTransferAccount.number
                                },
                                "OnlinePaymentDisabled": form.onlinePaymentDisabled,
                            },
                            "TrainEnrollFile": trainEnrollFile,
                            "TrainEnrollClass": trainEnrollClass,
                            "EnrollPictureFiles": enrollImages,
                            "EnrollDocFiles": enrollFiles,
                            "CheckinPictureFiles": reportImages,
                            "CheckinDocFiles": reportFiles
                        }
                    }
                    let loading = this.$loading({
                        text:"保存中",
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    })
                    if(this.type == 0){
                        this.$api.CreateTrainEnroll(sendData).then(data=>{
                            loading.close();
                            if(data.Code == 0){
                                this.$message.success('培训报名创建成功，2秒后返回列表');
                                setTimeout(()=>{
                                    this.$router.back();
                                },1500)
                            }
                        }).catch(()=>{
                            loading.close();
                        })
                    }else{
                        this.$api.AlterTrainEnroll(sendData).then(data=>{
                            loading.close();
                            if(data.Code == 0){
                                this.$message.success('培训报名修改成功，2秒后返回列表');
                                setTimeout(()=>{
                                    this.$router.back();
                                },1500)
                            }
                        }).catch(()=>{
                            loading.close();
                        })
                    }
                }else{
                    this.$message.error('填写信息有误，请查看！');
                }
            })
        }
    },
};
</script>
<style scoped>
@import "~@/assets/css/clear-el.css";
.tip{
    line-height: 1.8em;
    color: #9c9c9c;
}
.vertical{
    height: 100%;
}
.files{
    margin-left: 10px;
}
.files ul{
    margin-left: 0;
    margin-bottom: 20px;
}
.files li{
    display: flex;
    align-items: center;
    color: #606266;
    margin-bottom: 10px;
}
.more{
    color: #606266;
}
.more > div{
    margin-bottom: 5px;
}
.more .el-input{
    width: 70px;
}
.files li>span:nth-of-type(1){
    width: 30px;
    font-size: 22px;
}
.files li .button .el-button{
    position: relative;
    display: inline-block;
    cursor: pointer;
}
.files li .button input{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}
.files li .el-form-item{
    margin-bottom: 0;
    margin-right: 15px;
}
.files li .state{
    width: 140px;
    margin: 0 10px;
}
.files li .state .state1{
    color: #333333;
}
.files li .state .state2{
    color: #409eff;
}
.files li .state .state3{
    color: #f56c6c;
}
.classFee ::v-deep input{
    text-align: right;
}
</style>